export default __webpack_public_path__ + "static/media/marakanda.1bde0624.jpg";